import React, { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Cookies from 'js-cookie'
import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";


import Lst_officer from '../officers/lst_officer'
import Autorize from '../../../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Lst_Clubs({secteur,MyAnnee}) {

    const [listClub, setListClub] = useState("");   
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");
  
 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    
    useEffect(() => { 
                        
            if(autorize)
            {

    
                //, { headers: { Authorization: "Bearer "+ cookies }}
                MyAxios.get(process.env.REACT_APP_API + '/clubs/getClubBySecteur/'+ secteur + "/all/"+ MyAnnee) //axios.defaults.withCredentials = true
                .then((res) => {      
                    setErrorAxios(false);
                    console.log(res);
                    setListClub(res.data);
                
                })
                .catch((error) => {
                    console.log(error)  
                ///  if(error.status)  
                if(error.response.status === 401)// pas autorisé
                    setErrorAxios(true);  

                });
            }
       
    },[secteur,MyAnnee,autorize]);
   

    const navigate = useNavigate();       
    const dispatch = useDispatch();

                  
       
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      }; 
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
        return (
                <div>
                    <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                     
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                               
                               
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {Object.entries(listClub).map(([key, value]) => (
                                <TableRow
                                key={key}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                <TableCell align="right">{value.id}   </TableCell>
                                <TableCell align="right">{value.fk_club_master}   </TableCell>
                                <TableCell align="right">{value.ClubLegalName}   </TableCell>
                                <TableCell align="right">
                                <Lst_officer  key={value.fk_club_master} secteur={value.Default_DistrictNbr}  clubid={value.id} MyAnnee={MyAnnee} /> 
                                </TableCell>
                              
                                
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        </TableContainer>

                   
                </div>
       
        );
   
};

export default Lst_Clubs;